/**
 * Service to manage template loading from the pre-bundled template cache
 */
class TemplateCacheService {
  /** @ngInject */
  constructor($templateCache, $log) {
    this.$templateCache = $templateCache;
    this.$log = $log;
  }

  /**
   * Get a template from the cache
   * @param {string} templatePath - Path to the template
   * @returns {string} Template content or empty string if not found
   */
  getTemplate(templatePath) {
    const template = this.$templateCache.get(templatePath);
    if (!template) {
      this.$log.warn(`Template not found in cache: ${templatePath}`);
      return '';
    }
    return template;
  }

  /**
   * Check if a template exists in the cache
   * @param {string} templatePath - Path to the template
   * @returns {boolean} True if the template exists
   */
  hasTemplate(templatePath) {
    return !!this.$templateCache.get(templatePath);
  }
}

export default TemplateCacheService;
